import { useQuery } from '@tanstack/react-query';
import { serverStatsService, ServerStats } from '../api/serverStats.service';

const REFETCH_INTERVAL = 10 * 1000; // 10 seconds

export const useServerStats = () => {
  const { data, isLoading, error } = useQuery<ServerStats>({
    queryKey: ['serverStats'],
    queryFn: () => serverStatsService.fetchServerStats(),
    refetchInterval: REFETCH_INTERVAL,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    playerCount: data?.playerCount ?? 200,
    discordCount: data?.discordCount ?? 200,
    isOnline: data?.isOnline ?? true,
    isLoading,
    error,
  };
};
